// extracted by mini-css-extract-plugin
export default {"infoText":"OrderNeedPay_infoText__DTGW+","modal":"OrderNeedPay_modal__tJV1F"};